import { render } from "./AddCategoryModalComponent.vue?vue&type=template&id=6d9c60c9&scoped=true"
import script from "./AddCategoryModalComponent.vue?vue&type=script&lang=js"
export * from "./AddCategoryModalComponent.vue?vue&type=script&lang=js"

import "./AddCategoryModalComponent.vue?vue&type=style&index=0&id=6d9c60c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9c60c9"]])

export default __exports__